export { default } from './FAQ'
